import React from 'react';
import classnames from 'classnames';
import { cmxTypeguards, commonEnums, dragManager } from '@codametrix/ui-common';
import { Header } from './transaction-header';
import { BuildBody } from './transaction-body';
import './styles/index.scss';
const { ChargeSessionCodeType } = commonEnums;

const DRAGGABLE_CODES = new Set([
  ChargeSessionCodeType.MODIFIER,
  ChargeSessionCodeType.DIAGNOSIS
]);

/**
 * Method that builds an accordion element
 * @param handleKeyPress
 * @param handleBlurEvent
 * @param handleUnitsClick
 * @param handleCodeDelete
 * @param handleEnableTechPro
 * @param handleDisableTechPro
 * @param onFeatureSelection
 * @param panelActivations
 * @param medicalCode
 * @param idx
 * @param errors
 * @returns
 */
export const transactionAccordianBuilder = (
  handleKeyPress: (ev: any) => void,
  handleBlurEvent: (ev: any) => void,
  handleUnitsClick: (ev: any) => void,
  handleCodeDelete: (ev: any) => void,
  handleCodeChecked: (ev: any) => void,
  handleEnableTechPro: (
    techTransactionCodable: CMxCommonApp.TechCodableTransaction
  ) => void,
  handleDisableTechPro: (
    techTransactionCodable: CMxCommonApp.TechCodableTransaction
  ) => void,
  onFeatureSelection: (selection: CMxCommonApp.ChargeSessionSelection) => void,
  isTimeBasedCode: () => boolean,
  timeBasedCodePopup: () => React.ReactElement,
  panelActivations: CMxCommonApp.PanelActivations,
  invoice: CMxCommonApp.CodableInvoice,
  codeEdits: CMxCommonApp.CodeEditInputs,
  medicalCode: CMxCommonApp.ChargeSessionCode | CMxCommonApp.ZippedCodeBlock,
  idx: number,
  codableTransaction: CMxCommonApp.CodableTransaction,
  errors: AmplifyAPI.AmplifyError[] = []
) => {
  let styleClasses = '';
  let techTransaction: CMxCommonApp.TechTransaction = {
    proCode: null,
    techCode: null,
    hasProCode: false,
    hasTechCode: false,
    isProCodeActive: false,
    isTechCodeActive: false,
    proContext: null,
    techContext: null,
    isModifier: false,
    isLoading: false
  };
  techTransaction.isLoading = invoice?.isLoadingTechPro ?? false;

  if (cmxTypeguards.isZippedCodeBlock(medicalCode)) {
    // TORESOLVE: what should happen
  } else {
    const sessionCode = medicalCode as CMxCommonApp.ChargeSessionCode;
    styleClasses = `${sessionCode.codeType}-section`;
    const modifierTransaction =
      sessionCode?.codeType === 'modifier'
        ? codableTransaction?.modifiers.find(
            codableTransacMod =>
              codableTransacMod.modifier_code === sessionCode.code
          )
        : null;

    // assign tech/pro code if it exists
    if (
      sessionCode?.codeType === commonEnums.CodeTypes.PROCEDURE &&
      codableTransaction?.procedure?.procedure_code === sessionCode?.code
    ) {
      techTransaction.isModifier = false;
      // add tech/pro for procedure
      techTransaction.proCode =
        codableTransaction?.mapped_procedure?.procedure_code ?? null;
      techTransaction.techCode =
        codableTransaction?.technical_code?.code ?? null;

      techTransaction.hasProCode = !!codableTransaction?.mapped_procedure
        ?.procedure_code;
      techTransaction.hasTechCode = !!codableTransaction?.technical_code?.code;

      techTransaction.isProCodeActive = techTransaction.hasProCode
        ? codableTransaction?.mapped_procedure?.active
        : false;
      techTransaction.isTechCodeActive = techTransaction.hasTechCode
        ? codableTransaction?.technical_code?.active
        : false;

      techTransaction.proContext = {
        transactionGuid: codableTransaction.guid,
        mappedProcedure: codableTransaction?.mapped_procedure || null
      };
      techTransaction.techContext = {
        transactionGuid: codableTransaction.guid,
        technicalCode: codableTransaction?.technical_code || null
      };
    } else if (sessionCode?.codeType === commonEnums.CodeTypes.MODIFIER) {
      // case for modifiers
      techTransaction.isModifier = true;
      if (
        modifierTransaction?.modifier_type === commonEnums.ModifierTypes.PRO
      ) {
        techTransaction.proCode =
          codableTransaction?.mapped_procedure?.procedure_code ??
          codableTransaction?.procedure?.procedure_code ??
          '';
        techTransaction.hasProCode = true;
        techTransaction.isProCodeActive = true;
      } else if (
        modifierTransaction?.modifier_type === commonEnums.ModifierTypes.TECH
      ) {
        techTransaction.techCode =
          codableTransaction?.technical_code?.code ?? '';
        techTransaction.hasTechCode = true;
        techTransaction.isTechCodeActive = true;
      }
    }
  }

  return {
    className: classnames(styleClasses),
    header: Header(
      medicalCode,
      techTransaction,
      errors,
      invoice,
      codeEdits,
      handleKeyPress,
      handleBlurEvent,
      handleUnitsClick,
      handleCodeDelete,
      handleCodeChecked,
      handleEnableTechPro,
      handleDisableTechPro,
      isTimeBasedCode,
      timeBasedCodePopup
    ),
    data: medicalCode,
    selectable: !cmxTypeguards.isZippedCodeBlock(medicalCode),
    //@ts-ignore
    draggable: DRAGGABLE_CODES.has(medicalCode.codeType),
    id: `${idx}`,
    body: BuildBody(
      medicalCode,
      techTransaction,
      panelActivations,
      codeEdits,
      onFeatureSelection
    ),
    open: false
  };
};
